<template>
    <div class="content">
        <!-- swiper -->
        <div class="banner">
            <swiper ref="mySwiper" class="swiper">
                <swiper-slide
                    v-for="(item, index) in 1"
                    :key="index"
                    class="swiper-item"
                >
                    <img v-if="banner.picurl" :src="banner.picurl" class="swiper-item"/>
                </swiper-slide>
            </swiper>
        </div>



        <div class="content-report-box">
            <div class="navbar-box">
                <div class="navbar-item flc" :class="{'active-item':currentIndex == index }" v-for="(item,index) in navList" :key="index" @click="changeNavbar(index)">
                    {{item.name}}
                </div>
            </div>
            <div class="content-box">
                <div class="content-title">基础信息</div>
            </div>
        </div>
        <div>间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔间隔</div>
        <!-- swiper -->
        <div class="banner">
            <swiper ref="mySwiper" class="swiper">
                <swiper-slide
                        v-for="(item, index) in 1"
                        :key="index"
                        class="swiper-item"
                >
                    <img v-if="banner.picurl" :src="banner.picurl" class="swiper-item"/>
                </swiper-slide>
            </swiper>
        </div>
        <div class="center">
            <!-- user data -->
            <div class="div-padding userdata" v-if="user_sign">
                <!-- left -->
                <div class="user-left">
                    <img src="~@/assets/images/user/house/qds-head.png" alt=""/>
                </div>
                <!-- center -->
                <div class="user-center">
                    <div class="font-text">
                        专属服务人员：{{ user_sign.fullname }}
                    </div>

                    <!--<div class="cent">-->
                    <!--    <div class="star">-->
                    <!--        <img-->
                    <!--            v-for="i in 5"-->
                    <!--            src="~@/assets/images/user/house/star-icon.png"-->
                    <!--            alt=""-->
                    <!--        />-->
                    <!--    </div>-->
                    <!--    <div class="cent-text">4.8分</div>-->
                    <!--</div>-->
                </div>
                <!-- right -->
                <a :href="'tel:' + user_sign.mobilephone">
                    <div class="user-right"></div>
                </a>

            </div>
            <!-- basic -->
            <div class="div-padding basic" v-if="tags">
                <!-- title -->
                <div class="title">
                    <div class="title-left"></div>
                    <div class="font-tex3 title-text">基本信息</div>
                </div>
                <!-- content -->
                <div class="basic-item basic-padding font-tex2" v-for="(item, index) in tags" :key="item.id"
                     v-if="index % 2 == 0">
                    <div class="item-left">{{ tags[index].name }}：<span>{{ tags[index].items[0].name }}</span></div>
                    <div class="item-left">{{ tags[index + 1].name }}：<span>{{ tags[index + 1].items[0].name }}</span>
                    </div>
                </div>
                <!--<div class="basic-item font-tex2">-->
                <!--    <div class="item-left">装修情况：<span>毛坯房</span></div>-->
                <!--    <div class="item-left">水压大小：<span>大于1bar</span></div>-->
                <!--</div>-->
                <!--<div class="basic-item font-tex2">-->
                <!--    <div class="item-left">房屋保温：<span>良好</span></div>-->
                <!--    <div class="item-left">-->
                <!--        系统需求：<span>冷暖 新风</span>-->
                <!--    </div>-->
                <!--</div>-->
                <!--<div class="basic-item font-tex2">-->
                <!--    <div class="item-left">房屋层高：<span>3m</span></div>-->
                <!--    <div class="item-left">常住人口：<span>5人</span></div>-->
                <!--</div>-->
            </div>
            <!-- Survey -->
            <div class="div-padding survey">
                <!-- title -->
                <div class="title">
                    <div class="title-left"></div>
                    <div class="font-tex3 title-text">勘察信息</div>
                </div>
                <!-- content -->
                <div class="survey-head head-style">
                    <div
                            v-for="(item, index) in surveyHead"
                            :key="index"
                            class="font-text1"
                    >
                        {{ item }}
                    </div>
                </div>
                <template v-if="rooms">
                    <div
                            v-for="(item, index) in rooms"
                            :key="index"
                            class="survey-head survey-about font-text1"
                    >
                        <div>{{ item.name }}</div>
                        <div>{{ item.area }}</div>
                        <div>{{ item.direction_name }}</div>
                        <div>{{ item.floor }}</div>
                        <div class="survey-img" v-for="equ in item.equipments" :key="equ.type">
                            <img
                                    v-if="equ.num == 1"
                                    class="showImg"
                                    src="~@/assets/images/user/house/sure.png"
                                    alt=""
                            />
                        </div>
                    </div>
                </template>

                <!-- bottom -->
                <div class="survey-gross font-text" v-if="areas">
                    <div v-for="item in areas" :key="item.type">{{ item.name }}总面积：{{ arrTotal(item.num) }}m²</div>
                </div>
            </div>
            <!-- recommended -->
            <!--<div class="div-padding recommended">-->
            <!--    &lt;!&ndash; title &ndash;&gt;-->
            <!--    <div class="title">-->
            <!--        <div class="title-left"></div>-->
            <!--        <div class="font-tex3 title-text">推荐套餐</div>-->
            <!--    </div>-->
            <!--    &lt;!&ndash; recom &ndash;&gt;-->
            <!--    <div class="cecom">-->
            <!--        <img src="~@/assets/images/user/house/combo1.png" alt="">-->
            <!--        <img src="~@/assets/images/user/house/combo2.png" alt="">-->
            <!--        <img src="~@/assets/images/user/house/combo3.png" alt="">-->
            <!--        <img src="~@/assets/images/user/house/combo4.png" alt="">-->
            <!--        <img src="~@/assets/images/user/house/combo2.png" alt="">-->
            <!--    </div>-->
            <!--</div>-->

            <div class="div-padding basic">
                <!-- title -->
                <div class="title">
                    <div class="title-left"></div>
                    <div class="font-tex3 title-text">主机设备定位</div>
                </div>
                <!-- content -->
                <template v-if="position_kv">
                    <div class="basic-item basic-padding font-tex2" v-for="(item, index) in position_kv" :key="item.id"
                         v-if="index % 2 == 0">
                        <div class="item-left spb">
                            <span>{{ position_kv[index].position_item_name }}</span>
                            <span>{{ position_kv[index].name == 1 ? '配备' : position_kv[index].name }}</span>
                        </div>
                        <div class="item-left spb" v-if="position_kv[index + 1]">
                            <span>{{ position_kv[index + 1].position_item_name }}</span>
                            <span>{{ position_kv[index + 1].name == 1 ? '配备' : position_kv[index + 1].name }}</span>
                        </div>
                        <div class="item-left spb" v-if="(index +1) == position_kv.length && index % 2 == 0">
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                </template>

            </div>

            <!--  photos -->
            <div class="div-padding photos">
                <!-- title -->
                <div class="title">
                    <div class="title-left"></div>
                    <div class="font-tex3 title-text">勘察照片</div>
                </div>
                <template v-if="attach && curIndexArr">
                    <div
                            v-for="(arr, index) in attach"
                            :key="index"
                            class="photos-center"
                    >
                        <div class="item-pts">
                            <!-- title -->
                            <div class="item-title font-tex2">
                                <div class="title-box">
                                    <div v-for="(item2, index2) in arr"
                                         @click="changeCurrentIndex(index, index2)"
                                         :key="index2"
                                    >
                                        <span :class="index2 === curIndexArr[index] ? 'active-div' : ''">{{ item2.name }}</span>
                                    </div>
                                </div>

                                <div class="item-img" v-if="attach[index][(curIndexArr[index])]">
                                    <img v-for="(imgList, imgIndex) in attach[index][(curIndexArr[index])].attach"
                                         :src="imgList.img_url" :key="imgIndex" alt=""/>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
            <!--  scheme -->
            <div class="div-padding scheme">
                <!-- title -->
                <div class="title">
                    <div class="title-left"></div>
                    <div class="font-tex3 title-text">设计方案</div>
                </div>
                <div class="scheme-center" v-if="plans">
                    <img v-for="(item, index) in plans" :key="index" :src="item.img_url" alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {List} from "vant";

    export default {
        data() {
            return {
                currentIndex:0,//当前选中的navbar
                navList:[
                    {
                        name:'勘察信息'
                    },{
                        name:'设计定位'
                    }
                ], // navbar 列表
                surveyHead: [
                    "区域",
                    "面积",
                    "朝向",
                    "层高",
                    "风盘",
                    "地暖",
                    "散热片",
                    "新风",
                ], // 勘察head
                curIndexArr: null
            };
        },
        created() {
            this.$store.commit("loadSkeleton", {bool:true,type:"mapping"}); // 页面loading开启
            let contract_id = this.$route.query.contract_id || ''
            let report_id = this.$route.query.id || ''
            $init(() => {
                Promise.all([
                    this.$store.dispatch('memberProjectMapping/getData', { contract_id, report_id}),
                    this.$store.dispatch('banner/getData', 8)
                ]).then(() => {
                    let length = Math.ceil(this.rooms.length / 5)
                    this.curIndexArr = new Array(length).fill(0)
                    this.$store.commit("loadSkeleton", {bool:false,type:"mapping"}); // 页面loading开启
                })
            })
        },
        computed: {
            user_sign() {
                return this.$store.state.memberProjectMapping.user_sign
            },
            tags() {
                return this.$store.state.memberProjectMapping.tags
            },
            rooms() {

                return this.$store.state.memberProjectMapping.rooms
            },
            areas() {
                return this.$store.state.memberProjectMapping.areas
            },
            attach() {
                // console.log(this.$store.state.memberProjectMapping.attach, 'attach');
                return this.$store.state.memberProjectMapping.attach
            },
            plans() {
                return this.$store.state.memberProjectMapping.plans
            },
            position_kv() {
                return this.$store.state.memberProjectMapping.position_kv
            },
            banner() {
                return this.$store.state.banner.mapping
            }
        },
        methods: {
            changeNavbar (index) {
                if (index != this.currentIndex) {
                    this.currentIndex = index
                }
            },
            /**
             * 切换勘察照片tab
             */
            changeCurrentIndex(index, index2) {
                this.curIndexArr[index] = index2
                this.$forceUpdate()
            },
            /**
             * 计算总值
             */
            arrTotal(arr) {
                let total = arr.reduce((a, b) => {
                    return a + b
                })
                return total
            }
        },
    };
</script>

<style lang="scss" scoped>
    .content {
        -webkit-animation: fadeleftIn 0.4s;
        animation: fadeleftIn 0.4s;

        background: $userBg;

        .banner {
            .swiper {
                height: 366px;
                background: $defaultGary;
            }
        }
        .content-report-box {
            width: 100%;
            background:#7aa894;

            .navbar-box {
                background:#7aa894;
                height: 100px;
                width: 100%;
                display:flex;
                align-items: flex-start;
                padding: 24px;
                .navbar-item {
                    transition: all 0.4s;
                    height: 74px;
                    width: 50%;
                    font-size: 28px;
                    font-weight: 400;
                    color: #FFFFFF;
                    border-radius: 30px 30px 0px 0px;
                }
                .active-item {
                    height: 74px;
                    background: #355D4B;
                    border-radius: 30px 30px 0px 0px;
                    font-size: 28px;
                    font-weight: bold;
                    color: #FFFFFF;
                }
            }
            .content-box {
                width: 100%;
                background: #F9F9F9;
                border-radius: 24px;
                padding: 50px 32px;
                .content-title {
                    font-size: 32px;
                    font-weight: 500;
                    color: #333333;
                }
            }
        }
        .center {
            padding: 0 24px 24px 24px;

            .userdata {
                display: flex;
                align-items: center;
                justify-content: space-between;

                .user-left {
                    width: 120px;
                    height: 120px;
                    margin-right: 20px;
                    border-radius: 50%;
                    overflow: hidden;
                    background: $defaultGary;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                .user-center {
                    flex: 1;

                    .mid {
                        color: $comText1;
                    }

                    .bottom {
                        margin-top: 12px;
                        color: $deepGreen;
                    }

                    .cent {
                        margin-top: 20px;
                        display: flex;

                        .star {
                            display: flex;

                            img {
                                margin-right: 14px;
                                width: 32px;
                                height: 32px;
                            }

                            margin-right: 2px;
                        }

                        .cent-text {
                            font-size: 24px;
                            font-weight: 400;
                            color: #262525;
                            line-height: 32px;
                        }
                    }
                }

                .user-right {
                    width: 120px;
                    height: 120px;
                    background: url("~@/assets/images/user/house/phone.png") no-repeat center/100% 100%;
                }
            }

            .basic {
                .basic-item {
                    div {
                        flex: 2;
                    }

                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 18px 0 20px 0;
                    /*border-bottom: 1px dashed rgba(241, 241, 241, 1);*/
                    .item-right {
                        color: $comText1;
                    }

                    .item-left {
                        font-size: 28px;
                        color: #858585;
                        line-height: 40px;

                        span {
                            color: #222222;
                        }
                    }

                    .spb {
                        display: flex;

                        span:first-child {
                            font-size: 28px;
                            font-weight: 400;
                            color: #858585;
                            flex: 2;
                        }

                        span:last-child {
                            flex: 1;
                            text-align: right;
                            font-size: 28px;
                            font-weight: 400;
                            color: #222222;
                        }
                    }

                    .spb:nth-child(odd) {
                        margin-right: 60px;
                    }
                }

                .basic-padding {
                    padding-top: 26px;
                }
            }

            .survey {
                .survey-head {
                    display: flex;
                    justify-content: space-between;
                    align-content: center;

                    div:nth-child(1) {
                        width: 86px;
                    }

                    div:nth-child(2) {
                        text-align: center;
                        width: 62px;
                    }

                    div:nth-child(3) {
                        text-align: center;
                        width: 110px;
                    }

                    div:nth-child(4) {
                        width: 52px;
                        line-height: 37.5px;
                        text-align: center;
                    }

                    div:nth-child(5) {
                        text-align: center;
                        width: 80px;
                    }

                    div:nth-child(6) {
                        width: 52px;
                    }

                    div:nth-child(7) {
                        width: 80px;
                    }

                    div:nth-child(8) {
                        width: 52px;
                    }
                }

                .head-style {
                    padding: 30px 0 14px 0;
                    border-bottom: 1px solid $userBg;
                }

                .survey-about {
                    padding: 26px 0 28px 0;
                    border-bottom: 1px dashed $userBg;

                    div:nth-child(1) {
                        line-height: 36px;
                        color: $deepGreen;
                    }

                    div:nth-child(2) {
                        line-height: 36px;
                        color: $comText1;
                    }

                    .survey-img {
                        text-align: center;

                        .showImg {
                            width: 36px;
                            height: 36px;
                        }
                    }
                }

                .survey-gross {
                    margin-top: 24px;
                    font-size: 28px;
                    font-weight: 500;
                    color: #222222;

                    div {
                        display: inline-block;
                        margin: 0 108px 16px 0;
                    }

                    div:last-of-type {
                        margin: 0;
                    }

                    div:nth-child(2) {
                        margin-right: 0;
                    }
                }
            }

            .recommended {
                .cecom {
                    img {
                        width: 202px;
                        height: 192px;
                        margin: 24px 24px 0 0;
                    }

                    img:nth-child(3n) {
                        margin-right: 0;
                    }
                }
            }

            .photos {
                .photos-center {
                    padding-top: 30px;

                    .item-pts {
                        .item-title {
                            padding: 0 1px 20px 1px;

                            .title-box {
                                display: flex;
                                // justify-content: space-between;
                                justify-content: flex-start;

                                div {
                                    margin-left: 40px;
                                    text-align: center;
                                    height: 50px;
                                    width: 97px;
                                    font-size: 28px;
                                    font-weight: 400;
                                    color: #858585;
                                    // flex-grow:1;
                                    span {
                                        padding-bottom: 6px;
                                    }
                                }

                                div:first-child {
                                    margin-left: 0px;
                                    text-align: left;
                                }

                                div:nth-child(5) {
                                    text-align: right;
                                }

                                .active-div {
                                    font-weight: 500;
                                    color: #318544;
                                    border-bottom: solid 4px #318544;
                                }
                            }
                        }

                        .item-img {
                            img {
                                width: 200px;
                                height: 192px;
                                margin-right: 24px;
                            }

                            img:last-of-type {
                                margin-right: 0;
                            }
                        }
                    }

                    .border-line {
                        padding: 30px 0 0 0;
                        margin: 0 auto;
                        width: 654px;
                        height: 2px;

                        img {
                            width: 654px;
                            height: 2px;
                        }
                    }
                }
            }

            .scheme {
                .scheme-center {
                    margin-top: 20px;
                    min-height: 752px;
                    overflow: hidden;
                    background: #f7f7f7;
                    border-radius: 12px;
                }
            }
        }
    }

    .div-padding {
        margin-top: 24px;
        padding: 32px 24px 24px 24px;
        border-radius: 12px;
        background: $divBg;

        .title {
            display: flex;
            align-items: center;
            // padding-bottom: 8px;
            .title-left {
                width: 6px;
                height: 32px;
                background: $deepGreen;
                margin-right: 12px;
            }

            .title-text {
                color: $deepGreen;
            }
        }
    }

    // 卡片标题字号 - 14 个样式
    .font-text {
        // 28
        font-size: $baseSize;
        font-weight: 500;
    }

    .font-text1 {
        // 24
        font-size: $smallSize;
        font-weight: 400;
    }

    .font-tex2 {
        // 28
        font-size: $baseSize;
        font-weight: 400;
    }

    .font-tex3 {
        // 32
        font-size: $bigSize;
        font-weight: 500;
    }

    @keyframes fadeleftIn {
        0% {
            -webkit-transform: translate3d(100%, 0, 0);
            -webkit-transform: translate3d(100%, 0, 0);
            transform: translate3d(100%, 0, 0);
            transform: translate3d(100%, 0, 0);
        }
        100% {
            -webkit-transform: none;
            transform: none;
        }
    }

    @-webkit-keyframes fadeleftIn {
        0% {
            -webkit-transform: translate3d(100%, 0, 0);
        }
        100% {
            -webkit-transform: none;
        }
    }


    .flc{
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>
